<template>
    <BlockContainer
        :id="'cta-section-' + slugify(data.title)"
        :background-color="data.backgroundColor"
    >
        <div
            class="rounded-lg p-8 text-left lg:p-12"
            :class="data.sectionColor ? 'bg-' + data.sectionColor : null"
        >
            <div
                class="relative flex w-full flex-col items-center justify-between gap-4 text-white lg:flex-row lg:gap-2"
            >
                <div class="relative h-[80px] w-full lg:h-auto lg:w-auto">
                    <img
                        src="/images/cta-section/dashed-line-left.svg"
                        alt="dashed line left"
                        type="svg"
                        width="156"
                        height="43"
                        class="absolute -left-10 top-1 rotate-[50deg] lg:relative lg:left-auto lg:top-auto lg:rotate-0"
                    />
                </div>
                <h2 class="mb-0 text-center text-white lg:px-0">
                    {{ data.title }}
                </h2>
                <div class="flex justify-center">
                    <WysiwygContent
                        :content="data.text"
                        class="w-full text-center md:max-w-[600px] md:px-0"
                    />
                </div>
                <div
                    v-if="data.button"
                    class="flex w-full gap-x-2 md:w-auto md:px-0"
                >
                    <Button :button="data.button" class="w-full md:w-auto" />
                </div>
                <div class="relative h-[80px] w-full lg:h-auto lg:w-auto">
                    <img
                        src="/images/cta-section/dashed-line-right.svg"
                        alt="dashed line right"
                        type="svg"
                        class="absolute -right-12 bottom-2 rotate-[50deg] md:bottom-3 lg:relative lg:bottom-auto lg:right-auto lg:rotate-0"
                    />
                </div>
            </div>
        </div>
    </BlockContainer>
</template>

<script setup lang="ts">
import type { CtaSectionType } from '#shared/types/CtaSectionType';
import BlockContainer from '~/components/BlockContainer.vue';
import Button from '~/components/page-building/components/Button.vue';

defineProps<{
    data: CtaSectionType;
}>();
</script>
